import React, {PureComponent} from "react"
import styled from "styled-components"
import moment from "moment"

import Card from "@irati/ui/src/Layout/Card"
import {Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"

import {ScatterLineKeys, LAST_SUFFIX} from "./Keys"

type Closest = {
  key: string,
  value: number,
  valueConvertedToYCoordinate: number,
  date: string,
  originalDate: Date
}

interface Props {
  closest?: Closest,
  isMonthly?: boolean
}

const TooltipCard = styled(Card)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`

class CustomTooltip extends PureComponent<Props> {
  getLabelColour = () => {
    const {closest} = this.props

    switch (closest.key) {
      case ScatterLineKeys.OVERALL:
      case ScatterLineKeys.OVERALL_LAST:
        return theme.colors.primary2
      case ScatterLineKeys.PERKS:
      case ScatterLineKeys.PERKS_LAST:
        return theme.colors.primary1
      case ScatterLineKeys.CELEBRATION:
      case ScatterLineKeys.CELEBRATION_LAST:
        return theme.colors.tertiary.p_400
      case ScatterLineKeys.WELLNESS:
      case ScatterLineKeys.WELLNESS_LAST:
        return theme.colors.tertiary.i_400
      case ScatterLineKeys.CULTURE_HUB:
      case ScatterLineKeys.CULTURE_HUB_LAST:
        return theme.colors.secondary1
    }
  }

  getLabelText = () => {
    const {closest} = this.props

    switch (closest.key) {
      case ScatterLineKeys.OVERALL:
      case ScatterLineKeys.OVERALL_LAST:
        return "admin.components.dashboardGraph.legend.overall"
      case ScatterLineKeys.PERKS:
      case ScatterLineKeys.PERKS_LAST:
        return "admin.components.dashboardGraph.legend.perks"
      case ScatterLineKeys.CELEBRATION:
      case ScatterLineKeys.CELEBRATION_LAST:
        return "admin.components.dashboardGraph.legend.celebration"
      case ScatterLineKeys.WELLNESS:
      case ScatterLineKeys.WELLNESS_LAST:
        return "admin.components.dashboardGraph.legend.wellness"
      case ScatterLineKeys.CULTURE_HUB:
      case ScatterLineKeys.CULTURE_HUB_LAST:
        return "admin.components.dashboardGraph.legend.cultureHub"
    }
  }

  buildDate = () => {
    const {closest, isMonthly} = this.props

    const isTooltipOnLastLine = closest.key.includes(LAST_SUFFIX)

    const endMonth = isTooltipOnLastLine
      ? moment().format("MMM Do")
      : moment(closest.originalDate).subtract(1, "month").endOf("month").format("MMM Do")
    const endWeek = isTooltipOnLastLine
      ? moment().format("MMM Do")
      : moment(closest.originalDate).format("MMM Do")

    const startDate = isMonthly
      ? moment(closest.originalDate).subtract(1, "month").startOf("month").format("MMM Do")
      : moment(closest.originalDate).subtract(1, "week").format("MMM Do")
    const endDate = isMonthly ? endMonth : endWeek

    return `${startDate} - ${endDate}`
  }

  render() {
    const {closest} = this.props
    if(!closest) return null

    const labelText = this.getLabelText()

    return (
      <TooltipCard padding={[1]}>
        <Label small>{this.buildDate()}</Label>
        <Flex alignItems="center">
          <Label small color={this.getLabelColour()} marginRight={1}>
            <FormattedMessage id={labelText} />
          </Label>
          <Flex alignItems="center">
            <Label large fontWeight="bold" display="inline-block" paddingBottom={0}>{closest.value}</Label>
            <Label small display="inline-block">%</Label>
          </Flex>
        </Flex>
      </TooltipCard>
    )
  }
}

export default CustomTooltip
